import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from "@coreui/react";
import { Language } from "../../language/English";
const SearchMetaDataDeleteModal = (props: {showDeleteModal : boolean, setShowDeleteModal : Function, confirmDelete : Function}) => {
    return(
        <CModal alignment="center" visible={props.showDeleteModal} onClose={() => props.setShowDeleteModal(false)}>
            <CModalHeader>
                <CModalTitle>{Language.MESSAGE}</CModalTitle>
            </CModalHeader>
            <CModalBody> {Language.ARE_YOU_SURE_TO_DELETE_SEARCH_META_DATA} </CModalBody>
            <CModalFooter>
                <CButton color="secondary" onClick={() => props.setShowDeleteModal(false)}> {Language.NO} </CButton>
                <CButton color="primary" onClick={() => props.confirmDelete()}> {Language.YES} </CButton>
            </CModalFooter>
        </CModal>
    )
}
export default SearchMetaDataDeleteModal;